/**
 * Auth hooks for the embedded "Integration App" sign-in/sign-up pages
 * (pages/IntegrationApp/Auth/Components/{Signin,Signup}.jsx) — deliberately
 * separate from src/queries/auth.js (main app sign-in/sign-up/account-setup)
 * even though the shapes are similar, since these hit different backend
 * routes and carry integration-specific payload fields (user_type,
 * account_id). See src/queries/webhooks.js for the template this follows.
 */
import { useMutation } from "@tanstack/react-query";
import { request, ReqMethods } from "../lib/apiClient";

const { POST } = ReqMethods;

export function useIntegrationAppSignin() {
  return useMutation({
    mutationFn: (payload) => request(POST, "/auth/app/integration-signin", { payload }),
  });
}

export function useIntegrationAppSignup() {
  return useMutation({
    mutationFn: (payload) => request(POST, "/auth/app/integration-signup", { payload }),
  });
}
